<template>
  <div class="page sizeA4">
    <h4 class="text-center m-3">Edital de Convocação - Assembleia</h4>
    <p class="text-center m-3">Leia até o final e clique em "Ciente"</p>
    <div class="row">
      <div class="d-flex justify-content-center">
        <embed :src="this.urlTermo" style="height: 35vw; width: 75vw" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="d-flex justify-content-end">
        <b-button variant="success" @click="aceitar()">
          <i class="mdi mdi-check font-size-16 align-middle"></i>
          Ciente
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      urlTermo: "",
    };
  },

  created() {
    this.user = this.$store.state.me;
    this.buscarTermo();
  },

  methods: {
    buscarTermo() {
      this.loading = true;
      this.$http
        .get("api/reuniao/buscarTermo/" + this.$route.params.id, {
          responseType: "blob",
        })
        .then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          this.urlTermo = window.URL.createObjectURL(blob);
        });
    },

    aceitar() {
      this.$http
        .get("api/reuniao/aprovarTermo/" + this.$route.params.id)
        .then(async (response) => {
          if (!response.data.message) {
            await this.verificaDocumentoAssembleia();
          } else {
            this.$tools.alerta(response.data.message, "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    },

    async verificaDocumentoAssembleia() {
      this.$http
        .get("api/reuniao/verificarTermo")
        .then(async (response) => {
          const sq_upload = response.data.sq_upload;
          //Verifica se existe termo da assembleia (AGO, AGE) a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
          if (sq_upload) {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
            this.$store.commit("TERMO_ASSEMBLEIA", sq_upload);
            this.$router.push("/termo/assembleia/" + sq_upload);
          } else {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          }
          this.$router.push("/");
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          this.$router.push("/");
        });
    },
  },
};
</script>